import React from "react";
import { getLocalStorage } from "../utils";
import { Navigate, useLocation } from "react-router-dom";
import {
  ADMIN_ROUTES,
  AGENT_ROUTES,
  BUILDER_ROUTES,
  SALES_ROUTES,
} from "../constants/appRoutes";
import { LOCAL_STORAGE_KEYS, ROLES } from "../constants";

interface IProps {
  children: any;
  role: string;
}

const AuthorizationGaurd: React.FC<IProps> = ({ children, role }) => {
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);
  const location = useLocation();

  if (
    userRole === role ||
    ((userRole === ROLES.ADMIN || userRole === ROLES.STAFF) &&
      !location.pathname.startsWith(AGENT_ROUTES.ROOT) &&
      !location.pathname.startsWith(BUILDER_ROUTES.ROOT)) ||
    role === ROLES.CUSTOMER
  ) {
    return children;
  } else if (
    userRole === ROLES.AGENT &&
    (!location.pathname.startsWith(ADMIN_ROUTES.ROOT) ||
      !location.pathname.startsWith(SALES_ROUTES.ROOT) ||
      !location.pathname.startsWith(BUILDER_ROUTES.ROOT)) &&
    role !== ROLES.CUSTOMER
  ) {
    return <Navigate to={AGENT_ROUTES.ROOT} />;
  } else if (
    userRole === ROLES.BUILDER &&
    (!location.pathname.startsWith(ADMIN_ROUTES.ROOT) ||
      !location.pathname.startsWith(SALES_ROUTES.ROOT) ||
      !location.pathname.startsWith(AGENT_ROUTES.ROOT)) &&
    role !== ROLES.CUSTOMER
  ) {
    return <Navigate to={BUILDER_ROUTES.ROOT} />;
  } else if (
    userRole === ROLES.SALES &&
    (!location.pathname.startsWith(ADMIN_ROUTES.ROOT) ||
      !location.pathname.startsWith(BUILDER_ROUTES.ROOT) ||
      !location.pathname.startsWith(AGENT_ROUTES.ROOT)) &&
    role !== ROLES.CUSTOMER
  ) {
    return <Navigate to={SALES_ROUTES.ROOT} />;
  }
};

export default AuthorizationGaurd;
